import { createContext, useContext, useState } from 'react'

const TutorialContext = createContext()

export function TutorialProvider({ children }) {
  const [isActive, setIsActive] = useState(false)
  const [currentPage, setCurrentPage] = useState('dashboard')
  const [currentStep, setCurrentStep] = useState(0)

  return (
    <TutorialContext.Provider value={{
      isActive,
      setIsActive,
      currentPage,
      setCurrentPage,
      currentStep,
      setCurrentStep
    }}>
      {children}
    </TutorialContext.Provider>
  )
}

export function useTutorial() {
  const context = useContext(TutorialContext)
  if (!context) {
    throw new Error('useTutorial must be used within TutorialProvider')
  }
  return context
}
